<template>
  <div>
    <Header />
    <div class="verify-container container">
      <h4 class="text-center my-5 pb-5">
        <b>Verify Files signed by expertevidence.org online</b>
      </h4>
      <div class="row my-5">
        <div v-if="selectedFile" class="col-md-12">
          <div class="row">
            <div class="col-sm-4 text-center py-3">
              <img width="100px" src="../assets/images/paper.svg" />
            </div>
            <div class="col-sm-8">
              <table>
                <tr>
                  <th>Filename</th>
                  <td>{{ selectedFile.name }}</td>
                </tr>
                <tr>
                  <th>Last Modfied</th>
                  <td>{{ (new Date(selectedFile.lastModified)).toDateString() }}</td>
                </tr>
                <tr>
                  <th>Type</th>
                  <td>{{ selectedFile.type }}</td>
                </tr>
                <tr>
                  <th>size</th>
                  <td>{{ bytesToSize(selectedFile.size) }}</td>
                </tr>
              </table>
              <transition>
                <div key="1" v-if="!shaSum" class="progress mt-5">
                  <div class="progress-bar p-3" role="progressbar" :style="{ width: hashingProgress + '%' }"
                    aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                    <strong>{{ hashingProgress }} %</strong>
                  </div>
                </div>
                <div key="2" v-else class="hash-container border rounded mt-4">
                  <strong>
                    Hash :

                    <span class="txt-blue">{{ shaSum }}</span>
                  </strong>
                </div>
              </transition>
              <div v-if="signatureData">
                <div class="hash-container border rounded mt-2">
                  <strong>
                    Timestamp :
                    <span class="txt-blue">{{ signatureData.timestamp }}</span>
                  </strong>
                </div>
                <div class="hash-container border rounded mt-2">
                  <strong>
                    signature :
                    <span class="txt-blue">{{ signatureData.signature }}</span>
                  </strong>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div v-if="!selectedFile">
            <div class="file-upload-area">
              <input type="file" @change="fileSelectorCB" class="file-upload" />
              <div class="input-file-selector">
                <img height="50px" class="my-4" src="../assets/images/paper.svg" />
                <div class="p-3">
                  <h5>
                    <b>Select web archives or original digital document signed
                      by expertevidence.org
                    </b>
                  </h5>

                  <small> Drag and drop <br />or</small>
                </div>
                <button class="mt-2 btn">Select file</button>
              </div>
            </div>
          </div>
          <div v-if="!certFile && evType === 2">
            <div class="file-upload-area mt-4">
              <input type="file" accept=".sig" @change="certFileSelectorCB" class="file-upload" />
              <div class="input-file-selector">
                <img height="50px" class="my-4" src="../assets/images/certificate.svg" />
                <div>
                  <h5>
                    <b>Select the signature associated with <br />the original
                      data</b>
                  </h5>
                  or
                </div>
                <button class="mt-2 btn">Select files</button>
              </div>
            </div>
          </div>
          <div v-if="signatureCheckComplete">
            <div v-if="verificationStatus" class="my-5 pt-5 text-center">
              <img class="mb-4" width="100px" src="../assets/images/shield.svg" />
              <h4><strong>Verification Success !</strong></h4>
              <p>
                This file has been digitally signed by expertevidence.org at
              </p>
              <br />
              <div class="date-ctr d-inline-block container-sm p-3 rounded">
                <b>{{ new Date(parseInt(signatureData.timestamp)) }}</b>
              </div>
            </div>
            <div v-else class="my-5 pt-5 text-center">
              <img class="mb-4" width="100px" src="../assets/images/shield-error.svg" /><br />
              <h4><strong>Verification Failed !</strong></h4>
              <p>Original File or Signature appears to be Invalid</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import crypto from "crypto"
import Header from "./Header.vue"
import Footer from "./Footer.vue"
import FileSelector from "./FileSelector.vue"
const xorInplace = require("buffer-xor/inplace")
import chunkedSHA256 from "../functions/chunkedSHA256"
import truncate from "../functions/truncate"
import bytesToSize from "../functions/bytesToSize"

const EEO_PUBLIC_KEY = `
-----BEGIN PUBLIC KEY-----
MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEoUjjiSQoeMbunCWl1kBUyCvaw8y9
BS0MzeLo+S3y3P/dAEBB8ef6IGAjr6ZP21DSkFpzT5JnDZ4kNZjSAY4Aaw==
-----END PUBLIC KEY-----
`
export default {
  components: { Header, Footer, FileSelector },
  name: "Verify",

  data() {
    return {
      isStepComplete: false,
      selectedFile: null,
      certFile: null,
      shaSum: null,
      hashingProgress: 0,
      signatureData: null,
      verificationStatus: false,
      evType: 1,
      signatureCheckComplete: false,
    }
  },
  methods: {
    certFileSelectorCB(e) {
      this.certFile = e.target.files[0]
      const reader = new FileReader()
      reader.onload = (loadEvent) => {
        this.signatureData = JSON.parse(atob(loadEvent.target.result))
        this.verifySignature()
      }
      reader.readAsText(this.certFile)
    },
    fileSelectorCB(e) {
      this.selectedFile = e.target.files[0]
      this.calculateHash()
      this.evType = 2
    },
    async calculateHash() {
      try {
        let tmp = await chunkedSHA256(this.selectedFile, (progress) => {
          this.hashingProgress = Math.round(progress * 100)
        })
        this.shaSum = tmp
      } catch (e) {
        console.log(e)
        this.errorMessage = "Unable to calculate hash"
      }
    },
    async verifySignature() {
      try {
        const digest = crypto.createHash("sha256")
        digest.update(this.signatureData.timestamp.toString())
        var finalData = await xorInplace(
          Buffer.from(this.shaSum, "hex"),
          digest.digest()
        )

        const verify = crypto.createVerify("sha256")
        verify.write(finalData)
        this.verificationStatus = verify.verify(
          EEO_PUBLIC_KEY,
          this.signatureData.signature,
          "base64"
        )
      } catch (e) {
        errorMessage = "Unable to verify the signatures"
      } finally {
        this.signatureCheckComplete = true
      }
    },
    truncate,
    bytesToSize,
  },
}
</script>
<style scoped>
.verify-container {
  padding: 50px;
  background-color: var(--background-secondary);
  margin-top: 50px;
  margin-bottom: 50px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  border-radius: 10px;
}

.txt-blue {
  color: #10a2e6;
}

.hash-container {
  padding: 10px;
  font-size: 13px;
  word-break: break-all;
  overflow: hidden;
}

.progress-text {
  animation: glow 1s infinite linear;
}

.progress-bar {
  background: #00c781;
}

.progress {
  height: 45px;
}

.file-upload-area {
  border: 5px dashed var(--border-color);
  border-radius: 10px;
  height: 380px;
  background-color: var(--background-primary);
}

.file-upload {
  width: 100%;
  height: 100%;
  align-items: center;
  text-align: center;
  opacity: 0;
}

.input-file-selector {
  align-items: center;
  text-align: center;
  color: #888888;
  margin-top: -380px;
  height: 380px;
  padding-top: 40px;
}

.input-file-selector button {
  background: #10a2e6;
  color: rgb(233, 233, 233);
  font-size: 13px;
  font-weight: 500;
}

table {
  table-layout: fixed;
  width: 100%;
}

tr {
  max-width: 100%;
  overflow: hidden;
  text-align: left;
  font-size: 12px;
}

td,
th {
  table-layout: fixed;
  min-width: 130px;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 8px;
  word-break: break-all;
}

.date-ctr {
  background-color: var(--primary-green);
  color: #fff;
  width: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/Verify.vue